import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import React from 'react'
import { calcRem } from '../__styling'

const StyledLabelPillText = styled('span')(() => ({
    backgroundColor: tokens.thenightly.colors.palette.uplate.light,
    borderRadius: calcRem(52),
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 2,
    paddingBottom: 2,
    color: tokens.thenightly.colors.palette.uplate.accent,

    margin: 0,

    fontFamily: 'Inter',
    fontSize: calcRem(12),
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: calcRem(16),
}))

export const FeaturePill = () => {
    return <StyledLabelPillText>Feature</StyledLabelPillText>
}
FeaturePill.displayName = 'FeaturePill'
